<div #modalElement
     [id]="getId()"
     class="modal"
     data-keyboard="false" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h1>Übungsreihen</h1>
                <button class="close-button float-end" data-bs-dismiss="modal" title="Schließen" type="button">
                    <i aria-hidden="true" class="fa fa-times"></i>
                </button>
            </div>
            @if (digiTrainerContent && digiTrainerContent.training) {
                <div class="modal-body">
                    @if (lastOpenedAssignments) {
                        <div class="modal-box blue">
                            <img [src]="'digi-trainer/digitrainer-icon-continue-recent.png' | asset" alt="link-logo"/>
                            <div class="box-content">
                                <span>weitermachen, wo ich <b>zuletzt geübt</b> habe</span><br>
                                <button (click)="quicklinkClick(lastOpenedAssignments, '')" class="link-button"
                                        title="Übungen öffnen">Übungen öffnen
                                </button>
                            </div>
                        </div>
                    }
                    @if (digiTrainerContent.training.individual && digiTrainerContent.training.individual.length) {
                        <div class="modal-box purple">
                            <img [src]="'digi-trainer/digitrainer-icon-strength-weakness.png' | asset" alt="link-logo"/>
                            <div class="box-content">
                                <span>an <b>meinen Stärken </b> und <b>Schwächen</b> arbeiten</span><br>
                                @for (individual of digiTrainerContent.training.individual; track $index) {
                                    <button (click)="quicklinkClick(individual.assignment, individual.name)" class="link-button"
                                            title="Übungen öffnen">{{ individual.name }}
                                    </button>
                                }
                            </div>
                        </div>
                    }
                    @if (digiTrainerContent.training.competence && digiTrainerContent.training.competence.length) {
                        <div class="modal-box green">
                            <img [src]="'digi-trainer/digitrainer-icon-goals.png' | asset" alt="link-logo"/>
                            <div class="box-content">
                                <span>an <b>aktuellen Lernzielen</b> und <b>Kompetenzen</b> arbeiten</span><br>
                                @for (competence of digiTrainerContent.training.competence; track competence) {
                                    <button (click)="quicklinkClick(competence.assignment, competence.name)" class="link-button"
                                            title="Übungen öffnen">{{ competence.name }}
                                    </button>
                                }
                            </div>
                        </div>
                    }
                    @if (digiTrainerContent.training.exercises && digiTrainerContent.training.exercises.length) {
                        <div
                                class="modal-box red">
                            <img [src]="'digi-trainer/digitrainer-icon-chapter.png' | asset" alt="link-logo"/>
                            <div class="box-content">
                                <span>passend zur aktuellen Seite üben</span><br>
                                <div class="grid-container">
                                    @for (exercise of digiTrainerContent.training.exercises; track exercise) {
                                        <button (click)="quicklinkClick(exercise.assignment ?? exercise.assignments, exercise.name)"
                                                class="link-button"
                                                title="Übungen öffnen">
                                            @if (exercise.icon) {
                                                <i class="fa {{exercise.icon}}"></i>
                                            }&nbsp;
                                            <span [innerHTML]="exercise.name | safeHtml: 'html'"></span>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }

        </div>
    </div>
</div>
